import Vue from 'vue'
import Vuex from 'vuex'

import { db, auth } from '@/firebase';
import moment from 'moment';
import helpers from '@/helpers';

import user from './user'
import config from './config'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {

		title: 'My marktimes',

		users: null,
		roles: null,

		unsaved: false,
		unsavedModal: false,

	},

	getters: {

		numOfVacDays(state) {
			var hoursTotal = 0;
			var vacationHours = {};

			if (state.user.marktimes && state.user.vacations && state.user.info) {

				var workingHours = (state.user.info.isPartTime) ? state.user.info.partTime : 8;

				state.user.vacations.forEach(vacation => {

					if (vacation.approved === undefined || vacation.approved === true || vacation.approved === null) {

						var from = new Date(vacation.from.seconds * 1000);
						var to = new Date(vacation.to.seconds * 1000);
						var hours = parseFloat(vacation.hours);

						for (var day = from; day <= to; day.setDate(day.getDate() + 1)) {

							if (helpers.isHoliday(day) || helpers.isSunday(day) || helpers.isSaturday(day)) continue
						
							if (day.getFullYear() === new Date().getFullYear()) {

								if (hours >= workingHours) {
									vacationHours[moment(day).format('YYYY-MM-DD')] = workingHours;
									hours -= workingHours;
								} else {
									vacationHours[moment(day).format('YYYY-MM-DD')] = hours;
								}
							}
						
						}
					}

				});


				state.user.marktimes.forEach(marktime => {
					if (marktime.year !== new Date().getFullYear()) return
					marktime.marktime.forEach((day, i) => {
						if (day.type === 'D') {

							var date = moment({
								year: marktime.year,
								month: marktime.month,
								day: i + 1
							}).format('YYYY-MM-DD');
							
							var hours = (day.halfday) ? workingHours / 2 : workingHours;
							vacationHours[date] = hours;
						}
					})
				})

				for (var i in vacationHours) {
					var date = moment(i, 'YYYY-MM-DD').toDate()
					if (helpers.isHoliday(date) || helpers.isSunday(date) || helpers.isSaturday(date)) continue
					hoursTotal += vacationHours[i]
				}
				
				if (hoursTotal) return parseFloat(hoursTotal / workingHours).toFixed(2);
			}


			return hoursTotal
		}
	},


	mutations: {
		'SET_TITLE' (state, title) {
			state.title = title
		},
		'SET_USERS' (state, data) {
			state.users = data
		},
		'SET_ROLES' (state, data) {
			state.roles = data
		},
		'SET_UNSAVED' (state, data) {
			state.unsaved = data
		},
		'SET_UNSAVED_MODAL' (state, data) {
			state.unsavedModal = data
		}
	},


	actions: {

		getUsers({commit}) {
			db
			.collection('users')
			.onSnapshot(data => {
				var users = []
				data.forEach(function(doc) {
					var obj = doc.data();
					obj.uid = doc.id;
					// workaround
					obj.subordinates = (obj.subordinates) ? obj.subordinates : obj.subordinates = []
					users.push(obj)
				});
				commit('SET_USERS', users)
			})
		},

		getRoles({commit}) {
			db
			.collection('roles')
			.onSnapshot(data => {
				var roles = []
				data.forEach(function(doc) {
					var obj = doc.data();
					obj.id = doc.id;
					roles.push(obj);
				});
				commit('SET_ROLES', roles)
			})
		},

	},

	modules: {
		user: user,
		config: config
	}
})
